function notesReducer(state: any, { type, payload }: any) {
  switch (type) {
    case "CHANGE_TARGET_NOTE":
      return { ...state, current: payload };
    case "UPDATE_LIST":
      return { ...state, list: payload };
    default:
      return state;
  }
}

export default notesReducer;
